import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import * as UI from "../../../../../modules/ui-kit";
import EntityCreateForm from "../../../components/EntityCreateForm";
import UpsertParameterGroup from "../ParameterGroupDetail/UpsertParameterGroup.graphql";

const DEFAULT_VALUES = {
    name: [],
    order: 0,
};

function toDefinition(values) {
    return {
        name: values.name,
        order: Number(values.order ?? 0),
    };
}

function renderFields({ saving, setValue, values }) {
    return (
        <>
            <UI.Field>
                <UI.FieldLabel>name</UI.FieldLabel>
                <UI.FieldDescription>Multi-language translations for the parameter group name</UI.FieldDescription>
                <UI.TranslatedInput
                    disabled={ saving }
                    label="name"
                    onChange={ (val) => setValue("name", val) }
                    value={ values.name }
                />
            </UI.Field>

            <UI.Field>
                <UI.FieldLabel>order</UI.FieldLabel>
                <UI.FieldDescription>Sort order index for ordering parameter groups</UI.FieldDescription>
                <UI.TextInput
                    disabled={ saving }
                    onChange={ (val) => setValue("order", val ? Number(val) : 0) }
                    placeholder="0"
                    type="number"
                    value={ String(values.order) }
                />
            </UI.Field>
        </>
    );
}

export default function ParameterGroupNew() {
    const [upsertParameterGroup] = useMutation(
        gql(UpsertParameterGroup),
        {
            awaitRefetchQueries: true,
            refetchQueries: [
                "ListParameterGroups",
            ],
        },
    );

    async function onCreate(definition) {
        const result = await upsertParameterGroup({ variables: { definition } });
        const payload = result.data?.upsertParameterGroup;
        return {
            errors: payload?.errors,
            redirectTo: payload?.parameterGroup?.id && `../${ payload.parameterGroup.id }`,
        };
    }

    return (
        <EntityCreateForm
            createLabel="Create Parameter Group"
            defaultValues={ DEFAULT_VALUES }
            jsonDescription="Raw parameter group JSON definition (name, order)"
            onCreate={ onCreate }
            renderFields={ renderFields }
            title="New Parameter Group"
            toDefinition={ toDefinition }
        />
    );
}
